import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';


export const useGetFlowNodeAccess = ({ crId, crFlowId, nodeId }) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  const {
    isLoading, isError, isSuccess, data,
  } = useQuery(
    ['Flow-Node-Access', orgId],
    async () => axiosInstance.get(flow(orgId).nodeAccess(crId, crFlowId, nodeId)),
    {
      onError: (error) => dispatch(showAlert({ message: error.response.data.message, type: 'error' })),
      refetchOnWindowFocus: false,
    },
  );

  return {
    isLoading, isError, isSuccess, data,
  };
};
